import React, {Component} from "react"
import {Scatter} from "react-chartjs-2"
import {
  CHART_MAX_HEIGHT, COGO_TRAINING_NO_OF_CYCLES_PER_SESSION,
  COGOLAND_ACTIVITY_TYPE_DESC,
  COLOR_ATTENTIVE,
  COLOR_DISENGAGED,
  COLOR_DISTRACTED, COLOR_EXEMPLARY,
  COLOR_FLUCUATING,
  COLOR_IMPUSIVE, COLOR_NAVY, COLOR_PROGRESSIVE, convertSessionIndexToX, hexToRGB,
  SCORE_CATEGORIES,
  SCORE_CATEGORY_RGBA_COLOR_MAP_COGOLAND,
  value2color
} from "../../../../constants"
import {RxEmitter} from "rxemitter"
import {injectIntl} from "react-intl"
import SvgRect from "../../../../components/report/SvgRect"
import triangleIcon from "../../../../images/icons/noun-triangle-104951.svg"
import {findActivityType} from "../../../cogoland/component/CogoLandSessionsTable"

import line_cycle_1 from '../../../../images/cogoland/line_cycle_1.png'
import line_cycle_2 from '../../../../images/cogoland/line_cycle_2.png'
import SvgText from "../../../../components/report/SvgText"

const fontSizeH = '15px'
const fontSizeP = '13px'
const getData = (cycle1Activities, cycle2Activities, fakeData, format) => {

  console.log('getData')
  console.log('cycle1Activities:')
  console.log(cycle1Activities)

  const pointStyleMap = {
    GAME_LEVEL_1: 'circle',
    GAME_LEVEL_2: 'rect',
    GAME_LEVEL_3: 'triangle'
  }

  const pointRadiusMap = {
    circle: 5,
    rect: 6,
    rectRot: 8,
    triangle: 8,
  }

  const pointColorMap = {
    circle: 'rgba(255,255,255,1)',
    rect: 'rgba(0,0,0,1)',
    rectRot: 'rgba(0,0,0,0)',
    triangle: 'rgba(0,0,0,0)',
  }

  const pointBorderColorMap = {
    circle: 'rgba(0,0,0,1)',
    rect: 'rgba(255,255,255,1)',
    rectRot: 'rgba(0,0,0,1)',
    triangle: 'rgba(0,0,0,1)',
  }

  const isMCQ = type => (_.startsWith(type, 'MCQ'))
  const isPVT = type => (_.startsWith(type, 'PVT'))
  const isGame = type => (_.startsWith(type, 'GAME'))
  const gameActivities1 = cycle1Activities.filter(a => isGame(a.type.name))
  const mcqActivities1 = cycle1Activities.filter(a => isMCQ(a.type.name))
  const pvtActivities1 = cycle1Activities.filter(a => isPVT(a.type.name))

  const gameActivities2 = cycle2Activities ? cycle2Activities.filter(a => isGame(a.type.name)) : undefined
  const mcqActivities2 = cycle2Activities ? cycle2Activities.filter(a => isMCQ(a.type.name)) : undefined
  const pvtActivities2 = cycle2Activities ? cycle2Activities.filter(a => isPVT(a.type.name)) : undefined

  const pointStyle = gameActivities1.map(a => pointStyleMap[a.type.name])

  const gameAttentions1 = gameActivities1.map((a, index) => fakeData ? fakeData[index] : a.averageAttention)
  const gameAttentions2 = gameActivities2 ? gameActivities2.map((a, index) => fakeData ? fakeData[index] + 15 : a.averageAttention) : undefined

  const backgroundDatasetsV2 = ['progressive', 'exemplary'].map(name => {
    const SCORE_CATEGORY_VALUE_MAP = {
      'exemplary': 100,
      'progressive': 40
    }
    const color = `rgba(${SCORE_CATEGORY_RGBA_COLOR_MAP_COGOLAND[name]},1)`
    return {
      borderColor: color,
      backgroundColor: color,
      showLine: true,
      fill: true,
      pointRadius: 0,
      data: _.times(COGO_TRAINING_NO_OF_CYCLES_PER_SESSION, n => {
        return {x: n + 1, y: SCORE_CATEGORY_VALUE_MAP[name]}
      })
    }
  })

  const buildGameAttentionDataset = (gameActivities, gameAttentions, pointStyle) => {
    const sessionMap = _.mapValues(_.groupBy(gameActivities, 'sessionIndex'), activities => {
      const attentions = _.filter(_.map(activities, 'averageAttention'), it => !_.isNil(it))
      let avgAttention = attentions.length > 0 ? _.sum(attentions) / attentions.length : 0
      return {
        avgAttention: avgAttention,
        activityType: activities[0].type.name
      }
    })
    const sessionIndexList = _.keys(sessionMap)


    return {
      label: format({id: 'attention'}),
      borderWidth: 1,
      borderColor: "rgb(0,0,0)",
      lineTension: 0,
      showLine: true,
      fill: false,
      pointRadius: pointStyle.map(style => (pointRadiusMap[style] + 2)),
      pointBackgroundColor: pointStyle.map(style => (pointColorMap[style])),
      pointBorderColor: pointStyle.map(style => (pointBorderColorMap[style])),
      // pointBackgroundColor: "rgb(0,0,0)",
      pointStyle: pointStyle,
      data: sessionIndexList.map((sessionIndex, index) => ({
        type: COGOLAND_ACTIVITY_TYPE_DESC[sessionMap[sessionIndex].activityType],
        x: convertSessionIndexToX(sessionIndex),
        y: sessionMap[sessionIndex].avgAttention ? _.round(sessionMap[sessionIndex].avgAttention, 0) : sessionMap[sessionIndex].avgAttention
      }))
    }
  }

  const CYCLE2_COLOR = `rgb(${hexToRGB('#0037C9')})`

  const game = {
    labels: ['Scatter'],
    datasets: [
      buildGameAttentionDataset(gameActivities1, gameAttentions1, pointStyle),
    ]
  }
  if (gameActivities2) {
    game.datasets.push({
      ...buildGameAttentionDataset(gameActivities2, gameAttentions2, pointStyle),
      borderColor: CYCLE2_COLOR,
      borderDash: [5, 5],
    })
  }
  game.datasets = _.concat(game.datasets, backgroundDatasetsV2)

  const buildMCQDataset = (mcqActivities) => {
    return {
      label: format({id: 'attention'}),
      borderWidth: 1,
      borderColor: "rgb(0,0,0)",
      lineTension: 0,
      showLine: true,
      fill: false,
      pointRadius: 0,
      // pointBackgroundColor: pointBackgroundColor,
      pointBackgroundColor: "rgb(0,0,0)",
      pointStyle: 'crossRot',
      data: mcqActivities.map((a, index) => ({
        type: COGOLAND_ACTIVITY_TYPE_DESC[a.type.name],
        x: convertSessionIndexToX(a.sessionIndex),
        y: _.round(a.averageAttention)
      }))
    }
  }

  const mcq = {
    labels: ['Scatter'],
    datasets: [
      buildMCQDataset(mcqActivities1),
    ]
  }

  if (mcqActivities2) {
    mcq.datasets.push({
      ...buildMCQDataset(mcqActivities2),
      borderColor: CYCLE2_COLOR,
      borderDash: [5, 5],
    })
  }
  mcq.datasets = _.concat(mcq.datasets, backgroundDatasetsV2)

  const buildReactionTimeDataset = (pvtActivities) => {
    return {
      label: format({id: 'chart.reactionTime'}),
      borderWidth: 1,
      borderColor: "rgb(0,0,0)",
      lineTension: 0,
      showLine: true,
      fill: false,
      pointRadius: 0,
      // pointBackgroundColor: pointBackgroundColor,
      pointBackgroundColor: "rgb(0,0,0)",
      pointStyle: 'crossRot',
      data: pvtActivities.map((a, index) => ({
        type: COGOLAND_ACTIVITY_TYPE_DESC[a.type.name],
        x: convertSessionIndexToX(a.sessionIndex),
        y: _.round(a.overallAverageReactionTime)/1000
      }))
    }
  }

  const reactionTime = {
    labels: ['Scatter'],
    datasets: [
      buildReactionTimeDataset(pvtActivities1)
    ]
  }
  if (pvtActivities2) {
    reactionTime.datasets.push({
      ...buildReactionTimeDataset(pvtActivities2),
      borderColor: CYCLE2_COLOR,
      borderDash: [5, 5],
    })
  }

  reactionTime.datasets = _.concat(reactionTime.datasets, [{
    showLine: true,
    fill: false,
    pointRadius: 0,
    data: _.times(COGO_TRAINING_NO_OF_CYCLES_PER_SESSION, n => {
      return {x: n + 1, y: 2000}
    })
  }])

  const buildAccuracyDataset = (pvtActivities) => {
    return {
      label: format({id: 'chart.accuracy'}),
      borderWidth: 1,
      borderColor: "rgb(0,0,0)",
      lineTension: 0,
      showLine: true,
      fill: false,
      pointRadius: 0,
      // pointBackgroundColor: pointBackgroundColor,
      pointBackgroundColor: "rgb(0,0,0)",
      pointStyle: 'crossRot',
      data: pvtActivities.map((a, index) => ({
        type: COGOLAND_ACTIVITY_TYPE_DESC[a.type.name],
        x: convertSessionIndexToX(a.sessionIndex),
        y: _.round(a.overallAverageAccuracy)
      }))
    }
  }

  const accuracy = {
    labels: ['Scatter'],
    datasets: [
      buildAccuracyDataset(pvtActivities1),
    ]
  }

  if (pvtActivities2) {
    accuracy.datasets.push({
      ...buildAccuracyDataset(pvtActivities2),
      borderColor: CYCLE2_COLOR,
      borderDash: [5, 5],
    })
  }

  accuracy.datasets = _.concat(accuracy.datasets, [{
    showLine: true,
    fill: false,
    pointRadius: 0,
    data: _.times(COGO_TRAINING_NO_OF_CYCLES_PER_SESSION, n => {
      return {x: n + 1, y: 2000}
    })
  }])

  return {
    game: game,
    mcq: mcq,
    reactionTime: reactionTime,
    accuracy: accuracy
  }
}

class CogolandOverallProgressChart extends Component {

  constructor() {
    super()
    this.state = {
      fakeData: undefined
    }
  }

  componentWillMount() {
    RxEmitter.on('EVENT_FAKE_DATA').subscribe((x) => {
      console.log('on EVENT_FAKE_DATA')
      console.log(x)
      this.setState({fakeData: x})
    });
  }

  render() {

    const format = this.props.intl.formatMessage

    const cycle1Sessions = this.props.cycle1Sessions
    const cycle2Sessions = this.props.cycle2Sessions
    const cycle1Index = this.props.cycle1Index
    const cycle2Index = this.props.cycle2Index

    const isPVT = findActivityType(cycle1Sessions, 'PVT')
    const getActivities = (sessions) => _.sortBy(_.flatMap(sessions.map(session => session.activities.filter(a => a.status.name === 'UPLOADED').map(a => ({sessionIndex: session.index, ...a})))), a => (a.sessionIndex * 100 + a.index))
    const cycle1Activities = cycle1Sessions ? getActivities(cycle1Sessions) : []
    const cycle2Activities = cycle2Sessions ? getActivities(cycle2Sessions) : undefined
    const data = getData(cycle1Activities || [], cycle2Activities, this.state.fakeData, format)

    const dataGame = data.game
    const dataMCQ = data.mcq
    const dataAccuracy = data.accuracy
    const dataReactionTime = data.reactionTime

    const forReport = this.props.forReport

    const chartFontConfig = {
      fontColor: "#000000",
      fontFamily: "Roboto, sans-serif",
    }

    const optionsGame = {
      animation: {
        duration: 0
      },
      maintainAspectRatio: false,
      elements: {
        line: {
          tension: .1,
        }
      },
      legend: {
        display: false,
      },
      scales: {},
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            if (tooltipItem.datasetIndex === 0 || tooltipItem.datasetIndex === 1) {
              const cellData = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              const session = cellData.x
              const attention = cellData.y
              const label = cellData.type ?
                `${format({id: 'cogoland.session.no'})}: ${session} | ${format({id: 'cogoland.activity.type'})}: ${cellData.type} | ${format({id: 'cogoland.activity.average.attention'})}: ${attention}`
                : `${format({id: 'cogoland.session.no'})}: ${session} | ${format({id: 'cogoland.activity.average.attention'})}: ${attention}`

              return label;
            }
          }
        }
      }
    }

    optionsGame.scales.xAxes = [{
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'game.sessions'}),
        ...chartFontConfig
      },
      gridLines: {
        display: true
      },
      ticks: {
        stepSize: 1,
        ...chartFontConfig
      }
    }]

    optionsGame.scales.yAxes = [{
      stacked: true,
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'attention'}) + ' (%)',
        ...chartFontConfig
      },
      gridLines: {
        display: true
      },
      ticks: {
        beginAtZero: true,
        stepSize: 20,
        min: 0,
        max: 100,
        ...chartFontConfig
      }
    }]

    const legendData = [
      {color: COLOR_ATTENTIVE, label: format({id: 'cogoland.attention.level.optimal'})},
      {color: COLOR_FLUCUATING, label: format({id: 'cogoland.attention.level.effective'})},
      {color: COLOR_IMPUSIVE, label: format({id: 'cogoland.attention.level.balanced'})},
      {color: COLOR_DISTRACTED, label: format({id: 'cogoland.attention.level.basic'})},
      {color: COLOR_DISENGAGED, label: format({id: 'cogoland.attention.level.minimal'})},
    ].reverse()


    const legend = (
      <div className="col-xs-12 m-b-sm">
        <div className={`col-xs-2 text-center ${forReport ? "report-p" : ""}`}><u>{format({id: "attention.level"})}</u>
        </div>
        {legendData.map((it) => {
          return (
            <div className={`col-xs-2 text-center ${forReport ? "report-p" : ""}`}>
              <SvgRect color={it.color} width={24} rx={5}/> {it.label}
            </div>
          )
        })}
      </div>)

    const optionsMCQ = _.cloneDeep(optionsGame)
    optionsMCQ.scales.xAxes = [{
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'quiz.sessions'}),
        ...chartFontConfig
      },
      gridLines: {
        display: true
      },
      ticks: {
        min: 1,
        stepSize: 2,
        ...chartFontConfig
      }
    }]

    const optionsAccuracy = _.cloneDeep(optionsGame)
    optionsAccuracy.scales.xAxes = [{
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'pvt.sessions'}),
        ...chartFontConfig
      },
      gridLines: {
        display: false
      },
      ticks: {
        min: 1,
        stepSize: 2,
        ...chartFontConfig
      }
    }]

    optionsAccuracy.scales.yAxes = [{
      stacked: true,
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'chart.accuracy'}),
        ...chartFontConfig
      },
      gridLines: {
        display: true
      },
      ticks: {
        beginAtZero: true,
        stepSize: 20,
        min: 0,
        max: 100,
        ...chartFontConfig
      }
    }]

    const optionsReactionTime = _.cloneDeep(optionsGame)
    optionsReactionTime.scales.xAxes = [{
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'pvt.sessions'}),
        ...chartFontConfig
      },
      gridLines: {
        display: false
      },
      ticks: {
        min: 1,
        stepSize: 2,
        ...chartFontConfig
      }
    }]
    optionsReactionTime.scales.yAxes = [{
      stacked: true,
      scaleLabel: {
        display: true,
        fontSize: forReport ? 18 : 12,
        labelString: format({id: 'chart.reaction.time'}),
        ...chartFontConfig
      },
      gridLines: {
        display: true
      },
      ticks: {
        reverse: true,
        beginAtZero: true,
        stepSize: 0.4,
        min: 0,
        max: 2,
        ...chartFontConfig,
        callback: (value)=>{
          return value.toFixed(3)
        }
      }
    }]

    let bgColorlegend =
      (<div className="col-xs-12 m-t-sm">
        <table>
          <tbody>
          <tr>
            <td style={{paddingRight: 25}}><b className={forReport ? "report-p" : "cogo-legend-p"}>{format({id: 'exemplary'})}</b></td>
            <td>
              <SvgRect color={COLOR_EXEMPLARY} width={30} height={100} rx={0}/>
            </td>
            <td style={{paddingLeft: 25}}>
              <p className={forReport ? "report-p" : "cogo-legend-p"}><b>{format({id: 'exemplary'})}</b>: {format({id: `exemplary.desc.${forReport?"report":"portal"}`})}</p>
            </td>
          </tr>
          <tr>
            <td style={{paddingRight: 25}}><b className={forReport ? "report-p" : "cogo-legend-p"}>{format({id: 'progressive'})}</b></td>
            <td>
              <SvgRect color={COLOR_PROGRESSIVE} width={30} height={100} rx={0}/>
            </td>
            <td style={{paddingLeft: 25}}>
              <p className={forReport ? "report-p" : "cogo-legend-p"}><b>{format({id: 'progressive'})}</b>: {format({id: `progressive.desc.${forReport?"report":"portal"}`})}</p>
            </td>
          </tr>
          </tbody>
        </table>
      </div>)

    const cycleLineLegend = [
      <div className={'col-xs-3'}></div>,
      <div className={'col-xs-6'}>
        <div className={`text-center ${forReport ? "report-p" : "cogo-legend-p"}`}>
          <img src={line_cycle_1} style={{height: 20}}/> {format({id:'cycle'})} {cycle1Index}
          {cycle2Index ? <img src={line_cycle_2} style={{height: 20}}/> : ""} {cycle2Index ? `${format({id:'cycle'})} ${cycle2Index}` : ""}</div>
      </div>,
      <div className={'col-xs-3'}></div>
    ]

    const buildChartTitleDesc = (title, desc)=>([
      <div style={{
        fontSize: fontSizeH,
        fontWeight: 'bold',
        fontFamily: "Roboto, Medium",
        color: COLOR_NAVY
      }}>{title}</div>,
      <div
        style={{fontSize: fontSizeP, fontFamily: "Roboto, Light"}}>{desc}</div>
    ])

    return (
      <div>
        <div className={"print-page-bottom"}>
          <div className="m-t-sm">
            {forReport ? ([
                <SvgText width={400} height={80}
                         weight="bold"
                         color={COLOR_NAVY}
                         text={format({id: "game.attention.chart"})}/>,
                <div className={"report-p"}>{format({id: 'cogoland.report.chart.game.desc'})}</div>
              ]
            ) : buildChartTitleDesc(format({id: "game.attention.chart"}), format({id: "cogoland.portal.chart.game.desc"}))}
          </div>


          <div className="col-xs-12 m-t-sm">
            <Scatter height={CHART_MAX_HEIGHT}
                     data={dataGame} options={optionsGame}
                     redraw
            />
          </div>

          <div className="col-xs-12 m-t-sm">
            <div className={`col-xs-3 text-right ${forReport ? "report-p" : "cogo-legend-p"}`}>
              <u>{format({id: "difficulty.level"})}</u></div>
            <div className="col-xs-9">
              <div className="col-xs-4 text-center">
                <div className={forReport ? "report-p" : "cogo-legend-p"}><i className="far fa-circle"
                                                                             style={{color: 'black'}}></i> {format({id: 'cogoland.activity.type.GAME_LEVEL_1'})}
                </div>
              </div>
              <div className="col-xs-4 text-center">
                <div className={forReport ? "report-p" : "cogo-legend-p"}><i className="fas fa-square"
                                                                             style={{color: 'black'}}></i> {format({id: 'cogoland.activity.type.GAME_LEVEL_2'})}
                </div>
              </div>
              <div className="col-xs-4 text-center">
                <div className={forReport ? "report-p" : "cogo-legend-p"}><img src={triangleIcon} style={{
                  width: 30,
                  height: 30
                }}/>{/*<i className="fa-triangle" style={{color: 'black', width: 12, height: 12}}></i>*/} {format({id: 'cogoland.activity.type.GAME_LEVEL_3'})}
                </div>
              </div>
            </div>
            {cycleLineLegend}

          </div>
          {isPVT ? bgColorlegend : ""}
        </div>



        <div className={"print-page-bottom"}>
          {isPVT ? ([
            (forReport ? (
                  <div className="m-t-sm">
                    <SvgText width={400} height={80}
                             weight="bold"
                             color={COLOR_NAVY}
                             text={format({id: "pvt.chart"})}/>
                    <div className={"report-p"}>{format({id: 'cogoland.report.chart.reaction.time.desc'})}</div>
                  </div>
                ) :
                (<div
                  className="m-t-sm">{buildChartTitleDesc(format({id: "pvt.reaction.chart"}), format({id: 'pvt.reaction.chart.desc'}))}</div>)
            ),
            (<div className="col-xs-12 m-t-sm">
              <div className={'col-xs-12'}>
                <Scatter height={CHART_MAX_HEIGHT}
                         data={dataReactionTime} options={optionsReactionTime}
                         redraw
                />
              </div>
              {cycleLineLegend}
            </div>),
            (forReport ? (
                <div className="col-xs-12 m-t-sm">
                  <div className={"report-p"}>{format({id: 'cogoland.report.chart.accuracy.desc'})}</div>
                </div>
              ) : (<div
                className="m-t-sm">{buildChartTitleDesc(format({id: "pvt.accuracy.chart"}), format({id: 'pvt.accuracy.chart.desc'}))}</div>)
            ),
            (<div className="col-xs-12 m-t-sm">
              <div className={"col-xs-12"}>
                <Scatter height={CHART_MAX_HEIGHT}
                         data={dataAccuracy} options={optionsAccuracy}
                         redraw
                />
              </div>

              {cycleLineLegend}
            </div>)
          ]) : ([
            <div className="m-t-sm">
              {forReport ? (
                [
                  <SvgText width={400} height={80}
                           weight="bold"
                           color={COLOR_NAVY}
                           text={format({id: "quiz.attention.chart"})}/>,
                  <div className={"report-p"}>{format({id: 'cogoland.report.chart.mcq.desc'})}</div>
                ]
              ) : buildChartTitleDesc(format({id: "quiz.attention.chart"}), format({id: "cogoland.portal.chart.mcq.desc"}))}
            </div>,
            (<div className="col-xs-12 m-t-sm">
              <div className={"col-xs-12"}>
                <Scatter height={CHART_MAX_HEIGHT}
                         data={dataMCQ} options={optionsMCQ}
                         redraw
                />
              </div>
              {cycleLineLegend}
            </div>)
          ])}

          {!isPVT ? bgColorlegend : ""}
        </div>

      </div>
    )
  }
}

export default injectIntl(CogolandOverallProgressChart)



// WEBPACK FOOTER //
// ./src/routes/enterprise/dashboard/components/CogolandOverallProgressChart.js